export default {
      id: "weather__raindrop-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__raindrop",
      toString: function () {
        return this.url;
      }
    }